
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wheels/pickup/chevrolet-silverado",
      function () {
        return require("private-next-pages/wheels/pickup/chevrolet-silverado.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wheels/pickup/chevrolet-silverado"])
      });
    }
  